import graphql from "babel-plugin-relay/macro";
import { Image, type ImageProps } from "react-native";
import { useFragment } from "react-relay";

import { WhooshIconColor } from "@whoosh/design-system/src/components/icons_v2/general";
import { getThumbnail } from "@whoosh/utilities/src/Cloudinary";

import { FacilityLogoSideNavFragment_club$key } from "./__generated__/FacilityLogoSideNavFragment_club.graphql";

type FacilityLogoProps = {
  imageProps?: Omit<ImageProps, "source" | "alt">;
  logoIdOverride?: string;
  imgAltTag?: string;
  clubRef: FacilityLogoSideNavFragment_club$key | null;
};

export const FacilityLogoSideNav = ({
  imageProps,
  logoIdOverride,
  imgAltTag = "Logo",
  clubRef,
}: FacilityLogoProps) => {
  const club = useFragment(FacilityLogoFragmentString, clubRef);
  const logoID = logoIdOverride || club?.logoImage?.publicId;
  const { style: imageStyle, ...imageRestProps } = imageProps ?? {};

  return logoID ? (
    <Image
      source={{
        uri: getThumbnail(logoID, 100, 100)?.toURL(),
      }}
      alt={imgAltTag}
      style={[{ width: 48, height: 48 }, imageStyle]}
      {...imageRestProps}
    />
  ) : (
    <WhooshIconColor width={48} height={48} />
  );
};

export const FacilityLogoFragmentString = graphql`
  fragment FacilityLogoSideNavFragment_club on Club {
    logoImage {
      # TODO(ENG-3436): Remove the publicId alias when legacy image props are retired.
      publicId: renderingKey
    }
  }
`;
